import { create } from "zustand";
import { persist } from "zustand/middleware";

interface RegistStepState {
  step: number;
  done: boolean;
}

interface RegistInfoActions {
  setStep: (step: number) => void;
  setDone: (done: boolean) => void;
}

export type RegistInfoStore = RegistStepState & RegistInfoActions;

const initialState: RegistStepState = {
  step: 0,
  done: false,
};

export const useRegistInfoStore = create<RegistInfoStore>()(
  persist(
    (set) => ({
      ...initialState,
      setStep: (step) => set({ step }),
      setDone: (done) => set({ done }),
    }),
    {
      name: "registInfo",
    }
  )
);
